import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import NotificationCardContainer from './NotificationCardContainer';
import expenseIcon from '../../assets/icons/expense-icon.png';
import callplanIcon from '../../assets/icons/callplan-icon.png';
import phoneIcon from '../../assets/icons/phone-icon.png';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import {
  deletenotificationDetails,
  notificationDetails,
  resetDeleteModal,
} from '../../redux/slice/notification';
import ErrorsPopup from '../sfc/ErrorsPopup';
import Button from '../../components/button/Button';
import Loader from '../../components/modal/Loader';

const Notification = ({ isDesktop = false }) => {
  const dispatch = useDispatch();
  const {
    data: notification,
    isLoading,
    isNotificationDelete,
  } = useSelector((state) => state.notificationInfo);

  const [showRemarks, setShowRemarks] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState({
    notifyMsg: '',
    notifyId: null,
  });

  const [animatedList, setAnimatedList] = useState([]);
  const [isClearing, setIsClearing] = useState(false);

  useEffect(() => {
    dispatch(notificationDetails());
  }, [isNotificationDelete]);

  // Sync redux → local list
  useEffect(() => {
    if (notification?.notificationMessage) {
      setAnimatedList(
        notification.notificationMessage.map((n) => ({
          ...n,
          isRemoving: false,
        }))
      );
    }
  }, [notification]);

  const onNotificationClick = (id, text) => {
    dispatch(resetDeleteModal());
    setNotificationMsg({ notifyMsg: text, notifyId: id });
    setShowRemarks(true);
  };

  const clearAll = () => {
    if (!animatedList.length || isClearing) return;

    setNotificationMsg({
      notifyMsg: 'Are you sure you want to clear all notifications?',
      notifyId: null,
    });

    setShowRemarks(true);
  };

  const startClearAllAnimation = () => {
    if (isClearing) return;
    setIsClearing(true);

    const STAGGER_COUNT = 6;
    const STAGGER_DELAY = 30;
    const CLEANUP_DELAY = 600;

    const idsToDelete = animatedList.map((item) => item.notificationId);

    for (let i = 0; i < Math.min(STAGGER_COUNT, animatedList.length); i++) {
      setTimeout(() => {
        setAnimatedList((prev) =>
          prev.map((item, index) =>
            index === i ? { ...item, isRemoving: true } : item
          )
        );
      }, i * STAGGER_DELAY);
    }

    setTimeout(() => {
      setAnimatedList((prev) =>
        prev.map((item, index) =>
          index >= STAGGER_COUNT ? { ...item, isRemoving: true } : item
        )
      );
    }, STAGGER_COUNT * STAGGER_DELAY + 20);

        setTimeout(async () => {
      setAnimatedList([]);
      await dispatch(deletenotificationDetails(idsToDelete));
      dispatch(notificationDetails());
      setIsClearing(false);
    }, CLEANUP_DELAY);
  };
  return (
    <div className="relative min-h-screen lg:min-h-0 flex flex-col">
      {isLoading ? (
        <div className="flex items-center justify-center h-screen">
          <Loader />
        </div>
      ) : (
        <>
          {showRemarks && (
            <div className="absolute inset-0 z-[999] bg-black/20">
              <div className="sticky top-1/2 -translate-y-1/2 flex justify-center">
                <div className="scale-90 origin-center w-[90%] max-w-xl">
                  <ErrorsPopup
                    show={showRemarks}
                    message={notificationMsg.notifyMsg}
                    onClose={() => {
                      setShowRemarks(false);
                      notificationMsg.notifyId === null
                        ? startClearAllAnimation()
                        : dispatch(
                          deletenotificationDetails([notificationMsg.notifyId])
                        );
                    }}
                  />
                </div>
              </div>
            </div>
          )}

          {/* Fixed Header – mobile only */}
          <div className="fixed top-0 left-0 right-0 z-50 bg-white lg:static">
            <div className="flex m-6 justify-between lg:justify-center lg:m-5">
              <button
                onClick={() => window.history.back()}
                className="lg:hidden"
              >
                <FontAwesomeIcon
                  icon={faAngleLeft}
                  className="text-primary text-xl"
                />
              </button>

              <p className="text-primary font-semibold text-xl lg:text-[#123C69] lg:text-[18px]">
                Notification
              </p>

              <div />
            </div>

            <div className="h-[1px] bg-[#B3B3B3] lg:m-5"></div>
          </div>

          {/* Notification list */}
          <div className="px-5 flex flex-col pt-[80px] lg:pt-0">
            {animatedList.length > 0 ? (
              animatedList.map((val, index) => (
                <div
                  key={val.notificationId}
                  className={`transition-all duration-500 ease-[cubic-bezier(.4,0,.2,1)]
                    ${val.isRemoving
                      ? 'translate-x-full opacity-0 scale-95'
                      : ''
                    } hover:bg-[#D56AC726]`}
                >
                  <NotificationCardContainer
                    text={val.notificationMessage}
                    icon={
                      val.notificationMessage
                        .toLowerCase()
                        .startsWith('expense')
                        ? expenseIcon
                        : phoneIcon
                    }
                    onNotificationClick={onNotificationClick}
                    id={val.notificationId}
                  />
                </div>
              ))
            ) : (
              <div className="flex justify-center items-center text-primary p-5">
                No Notifications
              </div>
            )}
          </div>

          {/* Sticky Clear All */}
          {animatedList.length > 1 && (
            <div className="fixed bottom-0 left-0 right-0 lg:sticky lg:left-auto lg:right-auto bg-white border-t border-gray-200 py-3 flex justify-center z-40">
              <Button
                label={isClearing ? 'Clearing...' : 'Clear All'}
                onClick={clearAll}
                disabled={isClearing}
                btBgColor="bg-primary"
                btTextColor="text-white text-sm"
                btHeight="h-8 lg:h-8 smAndMd:h-8"
                btWidth="w-24 lg:!w-24 smAndMd:!w-24"
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Notification;